export default function mapErrorsToForm(form, response) {
    for (const [name, error] of Object.entries(response?.data?.errors)) {
        form.find(`input[name="${name}"]`).after(`<label id="password-error" class="error">${error}</label>`);
    }
}
